export default class ContentSuggestions {
  constructor() {
    this._initialize();
  }

  _initialize() {
    // We store the suggestions in sessionStorage to decrease load because they don't need to change during a visit
    const contentSuggestionsFromSessionStorage = sessionStorage.getItem('content-suggestions');
    if (contentSuggestionsFromSessionStorage) {
      const dataFromStorage = JSON.parse(contentSuggestionsFromSessionStorage);
      this._initializeContentSuggestions(dataFromStorage.data.contentSuggestions);
    } else {
      const contentSuggestionsUri = '/api/v1/content-suggestions';
      fetch(contentSuggestionsUri)
        .then((response) => {
          if (!response.ok) {
            throw new Error('Network response was not ok.');
          }
          return response.json();
        })
        .then((jsonData) => {
          sessionStorage.setItem('content-suggestions', JSON.stringify(jsonData));
          this._initializeContentSuggestions(jsonData.data.contentSuggestions);
        })
        .catch((error) => {
          console.error('There was a problem with the fetch operation: ', error);
        });
    }
  }

  _initializeContentSuggestions(data) {
    const filteredData = this._filterDataToRespectCounterPageRestriction(data);

    const randomElements = this._extractRandomItems(filteredData, 6);
    const randomSuggestionsHtml = document.querySelector('[data-js-binding="search-suggestions-random"]');
    if (randomSuggestionsHtml) {
      // Prepend random suggestions to existing HTML element (we cannot have an own wrapper because auf Flexbox issues)
      randomSuggestionsHtml.innerHTML = this._createHtmlForSuggestions(randomElements) + randomSuggestionsHtml.innerHTML;
    }

    const extendedSuggestionsHtml = document.querySelector('[data-js-binding="search-suggestions-extended"]');
    if (extendedSuggestionsHtml) {
      // Prepend suggestions to existing element (we cannot have an own wrapper because auf Flexbox issues)
      extendedSuggestionsHtml.innerHTML = this._createHtmlForExtendedSuggestions(filteredData) + extendedSuggestionsHtml.innerHTML;
    }
    let event = new CustomEvent('ContentSuggestionsLoaded', {
      bubbles: true,
      cancelable: true
    });
    document.dispatchEvent(event);
  }

  _extractRandomItems(data, maxItems) {
    // Array.splice always manipulates the original element, so we need a copy here
    let allItems = data.slice(0);
    const randomItems = [];
    while (randomItems.length < maxItems && allItems.length > 0) {
      const randomIndex = Math.floor(Math.random() * allItems.length);
      const selectedItem = allItems.splice(randomIndex, 1)[0];
      randomItems.push(selectedItem);
    }
    return randomItems;
  }

  _createHtmlForExtendedSuggestions(data) {
    const groupTitles = this._extractSortedGroupTitles(data);
    return groupTitles.map((groupTitle) => `
      <div class="search-extended__section">
        <h3>${groupTitle}</h3>
        <div class="search-extended__tags">${this._getHtmlForSuggestionsForGroup(groupTitle, data)}</div>
      </div>
    `).join('\n');
  }

  _extractSortedGroupTitles(data) {
    const groupTitlesSet = new Set();
    data.forEach((suggestion) => {
      groupTitlesSet.add(suggestion.groupTitle);
    });

    // Convert the Set to an array and sort by groupSortingIndex
    const groupTitlesArray = Array.from(groupTitlesSet);
    groupTitlesArray.sort((a, b) => {
      const aSortingIndex = data.find((suggestion) => suggestion.groupTitle === a).groupSortingIndex;
      const bSortingIndex = data.find((suggestion) => suggestion.groupTitle === b).groupSortingIndex;
      return aSortingIndex - bSortingIndex;
    });
    return groupTitlesArray;
  }

  _getHtmlForSuggestionsForGroup(groupTitle, data) {
    const suggestionsForGroup = data.filter((suggestion) => suggestion.groupTitle === groupTitle);
    return this._createHtmlForSuggestions(suggestionsForGroup);
  }

  _createHtmlForSuggestions(contentSuggestions) {
    const html = [];
    for (const suggestion of contentSuggestions) {
      const {targetPageUri, wordings} = suggestion;
      const randomIndex = Math.floor(Math.random() * wordings.length);
      const randomWording = wordings[randomIndex];
      const linkHTML = `<a href="${targetPageUri}" title="${randomWording}" class="tag">${randomWording}</a>`;
      html.push(linkHTML);
    }
    return html.join('\n');
  }

  /*
    If we are on a Counter Page, we only want to display results relevant to the current Counter Page
    If we are not on a Counter Page but a Counter was selected explicitly before (which was then set as a Cookie), we use this
    If we are neither on a Counter Page nor have selected a Counter before, we use all non-restricted data
   */
  _filterDataToRespectCounterPageRestriction(data) {
    const currentOrLastSelectedCounterPage = document.body.dataset.counterPage || this._getCookie('lastSelectedCounterPage') || null;
    if (currentOrLastSelectedCounterPage) {
      return data.filter((item) => {
        return !item.hasOwnProperty('restrictToCounterPages') || item.restrictToCounterPages.includes(currentOrLastSelectedCounterPage);
      });
    } else {
      return data.filter((item) => {
        return !item.hasOwnProperty('restrictToCounterPages');
      });
    }
  }

  // Source: https://stackoverflow.com/a/15724300
  _getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  }

}

